"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

var card_list_item_1 = require("./card-list-item");

var card_header_1 = require("./card-header");

require("./card.scss");

var Card = function Card(_a) {
  var header = _a.header,
      items = _a.items,
      dark = _a.dark,
      children = _a.children,
      maxWidth = _a.maxWidth;
  var style = undefined;

  if (maxWidth) {
    style = {
      maxWidth: maxWidth
    };
  }

  return react_1["default"].createElement("div", {
    className: "card " + (dark ? "dark" : ""),
    style: style
  }, react_1["default"].createElement(card_header_1.CardHeader, __assign({}, header)), children, items && items.map(function (item, idx) {
    return react_1["default"].createElement(card_list_item_1.CardListItem, __assign({
      key: idx
    }, item));
  }));
};

exports.Card = Card;
Card.defaultProps = {
  items: [],
  dark: false
};